module.exports = __webpack_public_path__ + "img/fundacja_pp.322b6be0.jpg";